import { constants } from 'helpers/constants'

export const isAuthenticated = () => {
    return !!localStorage.getItem(constants.CONNECT_USER)
}
